<template>
	 <b-modal  hide-footer hide-header v-model="remove_modal" @hide="hideRemoveModal"
     id="remove-module" title="Remove Module" ok-title="ok_title">
        <div v-if="ok_title == 'Remove'" class="remove-text">Are you sure you want to remove "<b>{{modalToRemove.module.title}}</b>" from your program? </div>
         <div v-else class="remove-text">Are you sure you want to delete "<b>{{modalToRemove.name}}</b>" ? </div>
            <div class="button-holder">
                <button class="cancel-button" @click="closeModal">Cancel</button>
                <button class="remove-button" @click="removeModuleFromChart">Remove</button>
                
            </div>
	
    </b-modal>
</template>
<script>

export default {
	props:['remove_modal','modalToRemove','modal_view', 'ok_title'],
	data: function(){
		return{
		}
		
	},
	methods:{
		removeModuleFromChart: function(){
            if(this.ok_title == 'Remove'){
                this.$emit('removeModuleFromChart',this.modalToRemove.module, this.modal_view)

            }else{
                this.$emit('removeModuleFromChart',this.modalToRemove)
            }
		},
		closeModal: function(){
             this.$emit('closeModal')
		},
        hideRemoveModal: function(){
             this.$emit('closeModal')
        }

	}
}
</script>
<style>
.modal-body{
    min-height: 155px !important;

}
.button-holder{
    position: absolute;
    left:240px;
    top: 88px;
}

button:focus {outline:0;}
.remove-text{
    margin: 32px 32px 16px 32px;
    width: 376px;
    height: 40px;
    background-color: rgba(255, 255, 255, 0);
    box-sizing: border-box;
    font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    word-wrap: break-word;
    font-style: normal;
    font-size: 16px;
    line-height: 20px;
    color: #333333;
    text-align: left;
    line-height: 20px;
}
.remove-button{
    cursor: pointer;
    margin-left: 17px;
    margin-right: 35px;
    margin-bottom: 24px;
	border-width: 0px;
    top: 0px;
    width: 101px;
    height: 44px;
    background: inherit;
    background-color: rgba(245,103,120,1);
    border: none;
    border-radius: 3px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    text-align: center;
    color: #fff;
}
.cancel-button{
    cursor: pointer;
    margin-bottom: 24px;
	border-width: 0px;
    width: 101px;
    height: 44px;
    background: inherit;
    background-color: rgba(255, 255, 255, 0);
    border: none;
    border-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    color: #555555;
    text-align: center;
}

</style>




// WEBPACK FOOTER //
// src/components/shopify/RemoveModuleDialog.vue